import React from 'react';
import ConnectionsOperations from './comp/connectionsOperations/ConnectionsOperationsConnector';
import ConnectionEditorContainer from './comp/connectionEditorContainer/ConnectionEditorConnector';
import './manageConnectionPage.scss';

const title = "Admin - SFTP Connections";

class ManageConnectionPage extends React.Component {
  
  constructor(){
    super();
    this.state = { 
      isCreation: false,
      openConnectionEditorSlidingPanel: false
    };
  }
  
  componentWillMount() {
    document.title = title;    
  }

  handleOpenSlidingPanel = () => {
    this.setState({ isCreation: true });
    this.setState({ openConnectionEditorSlidingPanel: true });
  };

  handleCloseSlidingPanel = () => {
    this.setState({ isCreation: false });
    this.setState({ cancelConnectionEdition: false });
    this.setState({ openConnectionEditorSlidingPanel: false });
  };

  render() {
    return (
      <div className="manage-connection__page react-page">
        <h1>{title}</h1>
        <hr />
        <ConnectionEditorContainer 
          isCreation={ this.state.isCreation }
          openConnectionEditorSlidingPanel={ this.state.openConnectionEditorSlidingPanel }
          onCloseEditorSlidingPanel= { this.handleCloseSlidingPanel }
        />
        <ConnectionsOperations handleNewButton={ this.handleOpenSlidingPanel }/>
      </div>
    );
  }
}

export default ManageConnectionPage;



// WEBPACK FOOTER //
// ./src/components/manageConnection/ManageConnectionPage.js